<template>
    <div class="row-block compact-card">
        <ul class="columns-block">
            <li class="column">
                <div class="column-block">
                    <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
<!--                    <div class="bottom-part">&lt;!&ndash; order-status &ndash;&gt;-->
<!--                        <div class="bottom-block right-border">-->

<!--                        </div>-->
<!--                    </div>-->
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div class="order-number">
                      <PuSkeleton width="180px" class="skeleton-input"></PuSkeleton>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
                        <div class="date-block">
                            <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            <div style="width:20px;"></div>
                            <span class="date">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div class="order-insured">
                        <div>
                            <span>
                                <PuSkeleton width="90px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
<!--                    <div class="bottom-part order-company">-->
<!--                        <div class="bottom-block right-border">-->
<!--                            <div class="option-block">-->
<!--                                <div class="option">-->
<!--                                    <PuSkeleton width="90px" class="skeleton-input"></PuSkeleton>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </div>
                          <span class="option image">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </span>
                        </div>
                    </div>
<!--                    <div class="bottom-part">-->
<!--                        <div class="bottom-block">-->
<!--                            <span class="option image">-->
<!--                                <PuSkeleton width="100px" class="skeleton-input"></PuSkeleton>-->
<!--                            </span>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div>
                        <div class="price-block">
                            <div class="text">
                                <PuSkeleton width="50px" class="skeleton-input"></PuSkeleton>
                            </div>
                            <div class="text">
                                <PuSkeleton width="30px" class="skeleton-input"></PuSkeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>


<script>
import {orderMixin} from "@/mixin";
import {MoreOptions} from "@/views/history/components/index";

export default {
    name: 'RowBlockSkeleton',
}
</script>
